




import { Vue, Component, Prop } from "vue-property-decorator";
import moment from "moment";

import * as AdminProto from "@/proto/admin/all_pb";

import FormSection, { IFormSection } from "./components/FormSection.vue";
import { ClientInfo, EContentType } from "@/types";
import { ECountryCode } from "@/pagesCom/ClientInfo/index.dto";
import { removePlusSign } from "@/utils/common-utils";

@Component({
  components: {
    FormSection,
  },
})
export default class BusinessOwner extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  info!: ClientInfo;

  get country() {
    return this.info.country;
  }

  get businessOwnerData(): AdminProto.BusinessOwner.AsObject {
    return this.info?.businessOwner as AdminProto.BusinessOwner.AsObject;
  }

  get leftSection(): IFormSection[] {
    const countryCode = this.businessOwnerData.phonenumbercountrycode
      ? `+${removePlusSign(this.businessOwnerData.phonenumbercountrycode)}`
      : "";

    return [
      {
        title: "Details",
        data: [
          {
            label: "FULL NAME",
            type: EContentType.TEXT,
            content: this.businessOwnerData?.fullname || "N/A",
            visible: true,
          },
          {
            label: "PLACE OF BIRTH",
            type: EContentType.TEXT,
            content: this.businessOwnerData?.placeofbirth || "N/A",
            visible: this.country === ECountryCode.ID,
          },
          {
            label: "DATE OF BIRTH",
            type: EContentType.TEXT,
            content:
              (isNaN(+this.businessOwnerData?.dateofbirth)
                ? this.businessOwnerData?.dateofbirth
                : moment
                    .unix(+this.businessOwnerData.dateofbirth)
                    .format("DD MMM YYYY")) || "N/A",
            visible: this.country === ECountryCode.ID,
          },
          {
            label: "GENDER",
            type: EContentType.TEXT,
            content: this.businessOwnerData?.gender || "N/A",
            visible: this.country === ECountryCode.ID,
          },
          {
            label: "OCCUPATION",
            type: EContentType.TEXT,
            content: this.businessOwnerData?.occupation || "N/A",
            visible: this.country === ECountryCode.ID,
          },
          {
            label: "PHONE NO.",
            type: EContentType.TEXT,
            content:
              `${countryCode}${this.businessOwnerData.phonenumber}` || "N/A",
            visible: true,
          },
          {
            label: "EMAIL",
            type: EContentType.TEXT,
            content: this.businessOwnerData?.email || "N/A",
            visible: true,
          },
          {
            label: "TIN NO.",
            type: EContentType.TEXT,
            content: this.businessOwnerData?.taxidentificationnumber || "N/A",
            visible: this.country === ECountryCode.PH,
          },
          {
            label: "CITIZENSHIP",
            type: EContentType.TEXT,
            content: this.businessOwnerData?.citizenship || "N/A",
            visible: true,
          },
        ],
      },
    ];
  }

  get rightSection(): IFormSection[] {
    return [
      {
        title: "",
        data: [
          {
            label:
              this.country === ECountryCode.PH
                ? "OFFICE ADDRESS"
                : "ADDRESS ON KTP",
            type: EContentType.TEXT,
            content: `
            <span class="flex flex-col" >
              <span class="mb-1">
                ${this.businessOwnerData?.registeredaddressline1}
              </span>
              <span class="mb-1 ${
                this.businessOwnerData?.registeredaddressline2 ? "" : "hidden"
              }">
                ${this.businessOwnerData?.registeredaddressline2}
              </span>
              <span class="mb-1">
                ${this.businessOwnerData?.registeredregion || "N/A"}
              </span>
              <span class="mb-1">
                ${this.businessOwnerData?.registeredcity || "N/A"}, ${
              this.businessOwnerData?.registeredzipcode || "N/A"
            }
              </span>
              <span class="mb-1">
                ${this.businessOwnerData?.registeredcountry || "N/A"}
              </span>
            </span>`,
            visible: true,
          },
          {
            label: "CURRENT ADDRESS",
            type: EContentType.TEXT,
            content: `
            <span class="flex flex-col" >
              <span class="mb-1">
                ${this.businessOwnerData?.currentaddressline1}
              </span>
              <span class="mb-1 ${
                this.businessOwnerData?.currentaddressline2 ? "" : "hidden"
              }">
                ${this.businessOwnerData?.currentaddressline2}
              </span>
              <span class="mb-1">
                ${this.businessOwnerData?.currentregion || "N/A"}
              </span>
              <span class="mb-1">
                ${this.businessOwnerData?.currentcity || "N/A"}, ${
              this.businessOwnerData?.currentzipcode || "N/A"
            }
              </span>
              <span class="mb-1">
                ${this.businessOwnerData?.currentcountry || "N/A"}
              </span>
            </span>`,
            visible: true,
          },
        ],
      },
    ];
  }
}
